import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
    constructor(private readonly config: Configuration) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.indexOf('http') === -1) {
            req = req.clone({
                url: `${this.config.routing.api.baseUrl}/${req.url}`
            });
        }

        return next.handle(req);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/interceptors/base.url.interceptor.ts